function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dotProp from 'dot-prop-immutable';
var defaultState = {
  isLoading: false,
  isLoaded: false,
  settings: {
    stack: JSON.parse(sessionStorage.getItem('portal.signature.stack')) || null
  },
  translationMissing: {
    showNotification: false,
    url: null
  },
  enDictionary: null,
  dictionary: {
    data: null,
    isLoading: false,
    isLoaded: false
  },
  stacks: []
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_ENDICTIONARY':
      return _objectSpread(_objectSpread({}, state), {}, {
        enDictionary: action.enDictionary
      });
    case 'GET_DICTIONARY_REQUEST':
      return dotProp.set(state, 'dictionary.isLoading', true);
    case 'GET_DICTIONARY_SUCCESS':
      return dotProp.set(state, 'dictionary', {
        data: action.dictionary,
        language: action.language,
        isLoading: false,
        isLoaded: true
      });
    case 'GET_DICTIONARY_FAILURE':
      return dotProp.set(state, 'dictionary.isLoading', false);
    case 'GET_DEPENDENCIES_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoaded: true
      });
    case 'GET_DEPENDENCIES_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoaded: true,
        isLoading: false,
        error: {
          message: 'Unable to required dependencies.'
        }
      });
    case 'SET_LANGUAGE':
      return _objectSpread(_objectSpread({}, state), {}, {
        language: action.language
      });
    case 'SET_SETTINGS':
      // TODO: Remove this temp way to set settings also in localStorage
      var key = action.key,
        value = action.value;
      if (key === 'stack') {
        sessionStorage.setItem("portal.signature.".concat(key), JSON.stringify(value));
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, _defineProperty(_defineProperty({}, action.key, action.value), "isLoading", false))
      });
    case 'SET_MODULE_METADATA_STACKS':
      return _objectSpread(_objectSpread({}, state), {}, {
        stacks: action.stacks
      });
    case 'SAVE_SETTINGS_REQUEST':
    case 'LOAD_SETTINGS_REQUEST':
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, {
          isLoading: true,
          saveStatus: null
        })
      });
    case 'SAVE_SETTINGS_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, {
          isLoading: false,
          saveStatus: 'module_settings_save_success'
        })
      });
    case 'LOAD_SETTINGS_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, {
          isLoading: false
        })
      });
    case 'SAVE_SETTINGS_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, {
          isLoading: false,
          saveStatus: 'module_settings_save_failure'
        })
      });
    case 'LOAD_SETTINGS_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        settings: _objectSpread(_objectSpread({}, state.settings), {}, {
          isLoading: false,
          loadingFailure: true
        })
      });
    case 'UPDATE_TRANSLATION_MISSING':
      return _objectSpread(_objectSpread({}, state), {}, {
        translationMissing: action.translationMissing
      });
    default:
      return state;
  }
});